// extracted by extract-css-chunks-webpack-plugin
module.exports = {"opaqueGroupGiftRegItemCard":"group-gift-reg-item-card__opaqueGroupGiftRegItemCard__yySR9","fundingProgress":"group-gift-reg-item-card__fundingProgress__2DyI-"};